import { StatusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ProductUi } from '@/components/Product/Table/ProductUi';
import COLORS from '@/constants/colors';
import {
  ProductCatalogResponse,
  ProductResponse,
} from '@/data/api/model/product/productDto';
import { formatDollarAmount } from '@/utils/amounts';

export const productsResponseToProductsUi = (
  response: ProductCatalogResponse
): ProductUi[] => {
  return response.data.map((productResponse) =>
    productResponseToProductUi(productResponse)
  );
};

const productResponseToProductUi = (input: ProductResponse): ProductUi => {
  const image = input.images?.length ? input.images[0] : undefined;
  return {
    productId: input.product_id,
    skuId: input.sku_id,
    productNumber: `${input.product_number}`,
    name: input.name,
    seller: input.seller_name,
    price: formatDollarAmount(input.price),
    image,
    presentation: input.presentation ?? '',
    status: productStatusToBadge(input.product_status),
  };
};

function productStatusToBadge(status?: string): StatusBadgeUi {
  switch (status) {
    case 'published':
      return {
        textColor: COLORS.success_700,
        backgroundColor: COLORS.success_50,
        edgeColor: COLORS.success_200,
        text: 'Publicado',
        statusId: status,
      };
    case 'unpublished':
      return {
        textColor: COLORS.yellow_700,
        backgroundColor: COLORS.yellow_50,
        edgeColor: COLORS.yellow_200,
        text: 'No Publicado',
        statusId: status,
      };
    default:
      return {
        textColor: COLORS.gray,
        backgroundColor: COLORS.light_gray,
        edgeColor: COLORS.dark_gray,
        text: 'Desconocido',
      };
  }
}
